import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {StyledUserPrivacyFromWrapper, StyledUserPrivacySubTitle, StyledUserPrivacyTitle} from './style'
import {Checkbox} from '@/components/commons/checkbox/ChekBox'
import {Controller, useFormContext, useWatch} from 'react-hook-form'
import {useTranslation} from '@/translations/i18n'
import {UserYearSelector} from '@/features/users/components/user-year-selector/UserYearSelector'
import {UserPrivacyFormValidationSchema} from '@/features/users/types'

export const UserPrivacyForm = () => {
    const {t} = useTranslation()

    // methods
    const form = useFormContext<UserPrivacyFormValidationSchema>()

    // form observer
    const privacyB = useWatch({control: form.control, name: 'privacyB'})
    const privacyC = useWatch({control: form.control, name: 'privacyC'})
    const fm68 = useWatch({control: form.control, name: 'fm68'})
    const contractType = useWatch({control: form.control, name: 'contractType'})

    return (
        <StyledUserPrivacyFromWrapper>
            {contractType == 'employee' ? (
                <Flexbox gap={2}>
                    <Checkbox id="privacyC" {...form.register('privacyC')} />
                    <Flexbox direction="column">
                        <StyledUserPrivacyTitle>{t('users:privacy_c')}</StyledUserPrivacyTitle>
                        <StyledUserPrivacySubTitle>{t('users:privacy_c_description')}</StyledUserPrivacySubTitle>
                    </Flexbox>
                </Flexbox>
            ) : (
                <Flexbox gap={2}>
                    <Checkbox id="privacyB" {...form.register('privacyB')} />
                    <Flexbox direction="column">
                        <StyledUserPrivacyTitle>{t('users:privacy_b')}</StyledUserPrivacyTitle>
                        <StyledUserPrivacySubTitle>{t('users:privacy_b_description')}</StyledUserPrivacySubTitle>
                    </Flexbox>
                </Flexbox>
            )}
            <Flexbox gap={2}>
                <Checkbox id="fm68" {...form.register('fm68')} />
                <Flexbox direction="column">
                    <StyledUserPrivacyTitle>{t('users:fm68')}</StyledUserPrivacyTitle>
                    <StyledUserPrivacySubTitle>{t('users:fm68_description')}</StyledUserPrivacySubTitle>
                </Flexbox>
            </Flexbox>

            {(privacyB || privacyC || fm68) && (
                <Controller
                    control={form.control}
                    name="privacyYear"
                    render={({field}) => (
                        <UserYearSelector
                            label={t('commons:reference_year')}
                            value={field.value ?? undefined}
                            onChange={field.onChange}
                            yearsFromNow={-11}
                            reverseOrder
                        />
                    )}
                />
            )}
        </StyledUserPrivacyFromWrapper>
    )
}
